module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [_c('p', [_vm._v("\n        Thanks for signing up! You'll be receiving an email with more details momentarily.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-sm-1-5"
  }), _vm._v(" "), _c('img', {
    staticClass: "pure-u-1 pure-u-sm-3-5",
    attrs: {
      "src": require("../../assets/images/ipas.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Look forward to 8 handpicked, well rated IPAs every month.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        We want to keep the beers as fresh as possible.\n        That's why we ship out just once a month (around the 15th).\n        We're ecstatic to get great IPAs to you.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        If you have any questions, comments, suggestions you can email\n        us anytime at "), _c('a', {
    attrs: {
      "href": "mailto:support@tavour.com"
    }
  }, [_vm._v("support@tavour.com")]), _vm._v(".\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c958f82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/success/SuccessHopBomb.vue
// module id = 362
// module chunks = 1